import { createContext } from "react";
import { TypeTagBase } from "src/types/contentfulTypes";

interface TagStateContextType {
  filteredTags: TypeTagBase[] | [];
  setFilteredTags: React.Dispatch<React.SetStateAction<TypeTagBase[] | []>>;
}

export const FilteredTagsStateContext = createContext<
  TagStateContextType | undefined
>(undefined);
